import { lazy } from "react";

/**
 * Rutas
 */
import rutasIAM from "../apps/IAM/routes";
import rutasActualizacionComercio from "../apps/UpdateCommerce/routes";
import rutasRecaudoDirecto, {
  rutasGestionRecaudoDirecto,
} from "../apps/RecaudoDirecto/routes";

import rutasBancolombiaRecaudoEmpresarial, {
  listPermissionsBancolombia as listPermissionsRecaudoEmpresarialBancolombia,
} from "../apps/RecaudoIntegrado/RecaudoEmpresarialBancolombia/routes";
import rutasDaviviendaRecaudoEmpresarial, {
  listPermissionsDavivienda as listPermissionsRecaudoEmpresarialDavivienda,
} from "../apps/RecaudoIntegrado/RecaudoEmpresarialDavivienda/routes";

import rutasColpatria, {
  listPermissionsColpatria,
  rutasGestionColpatria,
} from "../apps/Colpatria/routes";
import rutasDaviviendaCB, {
  listPermissionsDavivienda,
  routesDaviplata,
} from "../apps/Corresponsalia/CorresponsaliaDavivienda/routes";
import { enumPermisosPractisistemas } from "../apps/Practisistemas/enumPermisosPractisistemas";
import {
  // rutasRecargas,
  rutasPines,
  // rutasSoat,
  rutasApuestas,
} from "../apps/Practisistemas/routes";

// import { rutasPinesVus } from "../apps/PinesVus/routes";
import { enumPermisosPinesVus } from "../apps/PinesVus/enumPermisosPinesVus";

import rutasPinesCrc, {
  listPermissionPermisosPinesColpatriaCRC,
} from "../apps/PinesCrc/routes";
import RoutesTelefoniaMovil from "../apps/TelefoniaMovil/routes";

/**
 * * Providers
 */
import { PermissionsPinesCrc } from "../apps/PinesCrc/permissions";
import ProvideLoteria from "../apps/LoteriaBog/components/ProvideLoteria";
import ProvidepinesVus from "../apps/PinesVus/components/ProvidepinesVus";

import rutasPinesCea, {
  listPermissionsPinesCea,
} from "../apps/PinesCea/routes";
import rutasAvalCB, {
  listPermissionsAval,
  listPermissionsGestionAval,
  rutasDaleGrupoAval,
  rutasRegistraduriaTramitesAval,
  rutasGestionGrupoAval,
  rutasVentaSegurosAval,
} from "../apps/Corresponsalia/CorresponsaliaGrupoAval/routes";
import rutasAgrarioCB, {
  listPermissionsAgrario,
  listPermissionsGestionAgrario, routesElectronicTally,
  rutasGestionAgrario,
} from "../apps/Corresponsalia/CorresponsaliaBancoAgrario/routes";
import rutasConfiguraciones, {
  rutasBloqueoComercioTodos,
} from "../apps/TrxParams/routes";
import rutasRecaudoMultiple, {
  listPermissionsRecaudoMultiple,
  rutasRecaudosMultiplesOperaciones,
} from "../apps/Corresponsalia/RecaudoMultiple/routes";
import rutasRecargasTullave, {
  rutasGestionRecargasTullave,
  listPermissionsTuLlaveAdmin,
} from "../apps/RecargasTuLlave/routes";
import routesAlmaseg from "../apps/Almaseg/routes"; //Modulo Almaseg
import routesOtrasEntidades from "../apps/OtrasEntidades/routes"; //ModuloOtrasEntidades
//Rutas Emcali
import routesEmcali from "../apps/Emcali/routes";

import rutasFundacionMujer from "../apps/FundacionMujer/routes";
// import rutasMovii from "../apps/Movii-pdp/routes";
import rutasMoviliza from "../apps/Moviliza/routes";
import rutasCreditosPdp from "../apps/CreditoFacilPdp/routes";
import rutasRecargasTranscaribe from "../apps/TransCaribe/routes";
import rutasCajaSocialCB, {
  listPermissionsCajaSocial,
} from "../apps/Corresponsalia/CorresponsaliaCajaSocial/routes";

import routesBloqueosCierreFinanciero from "../apps/BloqueosCierreFinanciero/routes";
import routesItau from "../apps/GestionItau/routes";
import routesGestionBCS from "../apps/GestionBCS/routes";
import rutasCerolioOAT from "../apps/Cerolio/CerolioOAT/routes";
import rutasCerolioAdmin from "../apps/Cerolio/CerolioAdmin/routes";

//Modulo Recarga Cupo
import routesRecargaCupo from "../apps/RecargaCupo/routes";
//Modulo Pasarela
import routesPasarelaCheckPay from "../apps/Pasarelas/routes";
//Rutas AsignacionQr
import routesAsignacionQr from "../apps/PasarelaAsignacionQr/routes";
//Rutas SoatRefacil
import {
  routesSoatRefacil,
  routesSoatRefacilGestion,
} from "../apps/SoatRefacil/routes";
import routesDavivienda from "../apps/Davivienda/routes";
import rutasPowwi from "../apps/Powwi/routes";

//Corresponsalia Itau
import rutasItauCB, {
  listPermissionsItau,
} from "../apps/Corresponsalia/CorresponsaliaItau/routes";

import routesAuditoriaLogs, {
  listPermissionsAuditoriaLogs,
} from "../apps/AuditoriaLogs/routes";

import rutasDepositosMasivos, {
  listPermissionsDepositosMasivosOperaciones,
  rutasDepositosMasivosOperaciones,
} from "../apps/Corresponsalia/DepositosMasivos/routes";

import { rutasPrivadasBilleteraBancoW } from "../apps/BancoW/routes";
import rutasMoviiTransfiya, {
  rutasMovii,
} from "../apps/Corresponsalia-Movii/routes";

import rutasRecaudoGenericoPDP, {
  rutasDevolucionRecaudoSinEfectivoOperaciones,
} from "../apps/RecaudoGenericoPDP/routes";

import rutasDispersionCupo from "../apps/DispersionCupo/routes";

import rutasPinesCRCOlimpia, { listaPermisosPinesCrcOlimpia } from "../apps/PinesCrcOlimpia/routes"
import rutasPinesCEAOlimpia, { listaPermisosPinesCeaOlimpia } from "../apps/PinesCeaOlimpia/routes";


// Corresponsalia Banco W
import rutasBancoW, {
  listPermissionsBancoW
} from "../apps/Corresponsalia/CorresponsaliaBancoW/routes";

//Rutas CrediBanco
import rutasCrediBanco, {
  listPermissionsCrediBanco,
} from "../apps/CrediBanco/routes";
import rutasParametrizacionDatafono  from "../apps/ParametrizacionDatafono/routes";



/**

 * * Logos
 */
const AppIcons = lazy(() => import("../components/Base/AppIcons"));

/**
 * * Paginas
 */

/**
 * Base
 */
const Transacciones = lazy(() => import("../pages/Transacciones"));

/**
 * Loteria
 */

const LoteriaBog = lazy(() => import("../apps/LoteriaBog/LoteriaBog"));

/** Loteria Bogota */
const venta = lazy(() => import("../apps/LoteriaBog/Views/Loteria"));
const Sorteos = lazy(() => import("../apps/LoteriaBog/Views/Sorteos"));
const DownloadArchivos = lazy(() =>
  import("../apps/LoteriaBog/Views/DownloadArchivos")
);
const ArchivosPagoPremios = lazy(() =>
  import("../apps/LoteriaBog/Views/ArchivosPagoPremios")
);
const DescargarArchivosS3 = lazy(() =>
  import("../apps/LoteriaBog/Views/DescargarArchivosS3")
);
const BorrarBilletes = lazy(() =>
  import("../apps/LoteriaBog/Views/Sorteos/Borrado_billetes")
);
const CrearSorteos = lazy(() =>
  import("../apps/LoteriaBog/Views/Sorteos/CrearSorteos")
);
const CargaArchivos = lazy(() =>
  import("../apps/LoteriaBog/Views/CargaArchivos")
);
const HistoricoCargues = lazy(() =>
  import("../apps/LoteriaBog/Views/HistoricoCargues")
);
const ArqueoBilletes = lazy(() =>
  import("../apps/LoteriaBog/Views/InventarioBilletes/ArqueoBilletes")
);
const PagoDePremios = lazy(() =>
  import("../apps/LoteriaBog/Views/PagoDePremios")
);
const Premios = lazy(() => import("../apps/LoteriaBog/Views/Premios"));
const HistoricoPagoPremios = lazy(() =>
  import("../apps/LoteriaBog/Views/HistoricoPagoPremios")
);
const Inventario = lazy(() => import("../apps/LoteriaBog/Views/Inventario"));
const CrearInventario = lazy(() =>
  import("../apps/LoteriaBog/Views/InventarioBilletes/Inventario")
);
const ReportInventario = lazy(() =>
  import("../apps/LoteriaBog/Views/InventarioBilletes/ReportesInventario")
);

/**
 * Cupo
 */
const cupo = lazy(() => import("../apps/Cupo/Cupo"));
const DtlMovCupo = lazy(() =>
  import("../apps/Cupo/Views/LimiteCupo/DtlMovComercio")
);
const cupoComercio = lazy(() => import("../apps/Cupo/Views/CupoComer"));
const CrearCupo = lazy(() => import("../apps/Cupo/Views/CrearCupo"));
const ModifiCupo = lazy(() => import("../apps/Cupo/Views/ModifiLimiteCanje"));
const AjusteCupo = lazy(() => import("../apps/Cupo/Views/AjusteCupoComer"));
const TipoMovimientoCupo = lazy(() =>
  import("../apps/Cupo/Views/TipoMovimientoCupo")
);
const DetalleModificacionCupo = lazy(() =>
  import("../apps/Cupo/Views/DtlModifiCupo")
);
/**
 * Movii
 */
// const rutasMovii = lazy(() => import("../apps/Movii-pdp/routes"));
/**
 * Marketplace
 */
const MarketPlace = lazy(() => import("../apps/MarketPlace/MarketPlace"));
const ReporteGral = lazy(() => import("../apps/MarketPlace/Records/Crossval"));

/**
 * Pines Vus
 */
const PinesVus = lazy(() => import("../apps/PinesVus/PinesVus"));
/**
 * Formulario de actualizacion
 */

/**
 * Domiciliacion PPS
 */
const Domiciliacion = lazy(() => import("../apps/Domiciliacion/Domiciliacion"));
const comprobarEmail = lazy(() =>
  import("../apps/Domiciliacion/Views/BuscarComercioEmail")
);
const ModificarPps = lazy(() =>
  import("../apps/Domiciliacion/Views/ModificarPpsVoluntario")
);
const BuscarCedulaPpsADemanda = lazy(() =>
  import("../apps/Domiciliacion/Views/BuscarCedulaPpsADemanda")
);
/**
 * Recaudo
 */
const Recaudo = lazy(() => import("../apps/Recaudo/Recaudo"));
const RecaudoManual = lazy(() => import("../apps/Recaudo/Views/RecaudoManual"));
const RecaudoCodigo = lazy(() => import("../apps/Recaudo/Views/RecaudoCodigo"));

/**
 * Daviplata
 */
const Daviplata = lazy(() => import("../apps/Daviplata/DaviplataTrx"));
const Retiro = lazy(() => import("../apps/Daviplata/Views/Retiro"));
const Deposito = lazy(() => import("../apps/Daviplata/Views/Deposito"));

/**
 * Corresponsalia
 */
const Corresponsalia = lazy(() =>
  import("../apps/Corresponsalia/Corresponsalia")
);
/**
 * RecaudoEmpresarial
 */
const RecaudoEmpresarial = lazy(() =>
  import("../apps/RecaudoIntegrado/RecaudoEmpresarial")
);

/**
 * API-SMS
 */
const API_SMS = lazy(() => import("../apps/API-SMS/API_SMS"));
const EnviarSMS = lazy(() => import("../apps/API-SMS/Views/EnviarSMS"));
const CrearSMS = lazy(() => import("../apps/API-SMS/Views/CrearSMS"));
const reporteSMS = lazy(() => import("../apps/API-SMS/Views/ReporteSMS"));
const BloquearNum = lazy(() => import("../apps/API-SMS/Views/BloquearNum"));

const CARGAR =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_1-P9wrhr8RWkx5zt3f64Ogy-Yr5DoQ_5ww&usqp=CAU";
const DESCARGAR =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5Ra0nfafOoCnsF9kD-Q1BH_J-kkz4CsP4Yw&usqp=CAU";

/**
 * Modulo Gestion transaccional
 */
const GestionTransaccional = lazy(() =>
  import("../pages/GestionTransaccional")
);

/**
 * Gestion anulación pines OAT Colpatria
 */
const AnulacionesPinesOATColpatria = lazy(() =>
  import("../apps/PinesCrc/Views/AnulacionesPines")
);
const CargueAnulacionesPinesOATColpatria = lazy(() =>
  import("../apps/PinesCrc/Views/Anulaciones/CargueAnulaciones")
);
const DescargaPeticionesPinesOATColpatria = lazy(() =>
  import("../apps/PinesCrc/Views/Anulaciones/DescargarArchivoPeticiones")
);
const HistoricoAnulacionesPinesOATColpatria = lazy(() =>
  import("../apps/PinesCrc/Views/Anulaciones/HistoricoAnulaciones")
);

/**
 * Gestion anulación pines CRC
 */
const AnulacionesPinesCRC = lazy(() =>
  import("../apps/PinesCrc/Views/AnulacionesPines")
);
const CargueAnulacionesPinesCRC = lazy(() =>
  import("../apps/PinesCrc/Views/Anulaciones/CargueAnulaciones")
);
const DescargaPeticionesPinesCRC = lazy(() =>
  import("../apps/PinesCrc/Views/Anulaciones/DescargarArchivoPeticiones")
);
const HistoricoAnulacionesPinesCRC = lazy(() =>
  import("../apps/PinesCrc/Views/Anulaciones/HistoricoAnulaciones")
);

/**
 * Gestion anulación pines CEA
 */
const AnulacionesPinesCEA = lazy(() =>
  import("../apps/PinesCea/Views/AnulacionesPines")
);
const CargueAnulacionesPinesCEA = lazy(() =>
  import("../apps/PinesCea/Views/Anulaciones/CargueAnulaciones")
);
const DescargaPeticionesPinesCEA = lazy(() =>
  import("../apps/PinesCea/Views/Anulaciones/DescargarArchivoPeticiones")
);
const HistoricoAnulacionesPinesCEA = lazy(() =>
  import("../apps/PinesCea/Views/Anulaciones/HistoricoAnulaciones")
);

/**
 * Pines Combinados -- CRC y Comsión premium
 */
const PinesCombinados = lazy(() =>
  import("../apps/PinesVus/Views/PinesCombinados/CrearPin")
);

const allUrlsPrivateApps = [
  {
    link: "/GestionTransaccional",
    label: <AppIcons Logo={"PINES_ADMINISTRAR"} name="Gestión Transaccional" />,
    component: GestionTransaccional,
    permission: [
      63,
      53,
      ...listPermissionsTuLlaveAdmin,
      ...listPermissionsGestionAval,
      ...listPermissionsGestionAgrario,
      ...listPermissionsAuditoriaLogs,
      ...listPermissionsDepositosMasivosOperaciones,
    ],
    subRoutes: [
      // {
      //   link: "/GestionTransaccional/AnulacionesPinesCRC",
      //   label: (
      //     <AppIcons Logo={"PINES_ADMINISTRAR"} name={"Anulaciones Pines CRC"} />
      //   ),
      //   component: AnulacionesPinesCRC,
      //   permission: [63],
      //   subRoutes: [
      //     {
      //       link: "/GestionTransaccional/AnulacionesPinesCRC/CargueArchivo",
      //       label: (
      //         <AppIcons Logo={"CARGAR"} name={"Cargue Archivo Anulaciones"} />
      //       ),
      //       component: CargueAnulacionesPinesCRC,
      //       permission: [63],
      //     },
      //     {
      //       link: "/GestionTransaccional/AnulacionesPinesCRC/DescargarPeticiones",
      //       label: (
      //         <AppIcons
      //           Logo={"DESCARGAR"}
      //           name={"Descarga Archivo Peticiones"}
      //         />
      //       ),
      //       component: DescargaPeticionesPinesCRC,
      //       permission: [63],
      //     },
      //     {
      //       link: "/GestionTransaccional/AnulacionesPinesCRC/Historico",
      //       label: (
      //         <AppIcons Logo={"DESCARGAR"} name={"Histórico Anulaciones"} />
      //       ),
      //       component: HistoricoAnulacionesPinesCRC,
      //       permission: [63],
      //     },
      //   ],
      // },
      // {
      //   link: "/GestionTransaccional/AnulacionesPinesCEA",
      //   label: (
      //     <AppIcons Logo={"PINES_ADMINISTRAR"} name={"Anulaciones Pines CEA"} />
      //   ),
      //   component: AnulacionesPinesCEA,
      //   permission: [63],
      //   subRoutes: [
      //     {
      //       link: "/GestionTransaccional/AnulacionesPinesCEA/CargueArchivo",
      //       label: (
      //         <AppIcons Logo={"CARGAR"} name={"Cargue Archivo Anulaciones"} />
      //       ),
      //       component: CargueAnulacionesPinesCEA,
      //       permission: [63],
      //     },
      //     {
      //       link: "/GestionTransaccional/AnulacionesPinesCEA/DescargarPeticiones",
      //       label: (
      //         <AppIcons
      //           Logo={"DESCARGAR"}
      //           name={"Descarga Archivo Peticiones"}
      //         />
      //       ),
      //       component: DescargaPeticionesPinesCEA,
      //       permission: [63],
      //     },
      //     {
      //       link: "/GestionTransaccional/AnulacionesPinesCEA/Historico",
      //       label: (
      //         <AppIcons Logo={"DESCARGAR"} name={"Histórico Anulaciones"} />
      //       ),
      //       component: HistoricoAnulacionesPinesCEA,
      //       permission: [63],
      //     },
      //   ],
      // },
      rutasGestionColpatria,
      // rutasGestionRecargasTullave,
      // rutasGestionRecaudoDirecto,
      // rutasGestionGrupoAval,
      // rutasGestionAgrario,
      // routesItau,
      // routesDavivienda,
      // routesBloqueosCierreFinanciero,
      // routesGestionBCS,
      // routesAuditoriaLogs,
      // rutasDepositosMasivosOperaciones,
      // rutasRecaudosMultiplesOperaciones,
      // ...routesSoatRefacilGestion,
      // rutasDevolucionRecaudoSinEfectivoOperaciones,
      // routesElectronicTally,
      // rutasBloqueoComercioTodos,
      // rutasParametrizacionDatafono,
    ],
  },
  {
    link: "/transacciones",
    // label: <AppIcons Logo={"MARKETPLACE"} name="Transacciones" />,
    label: <AppIcons Logo={"TRANSACCIONES"} name="Consulta Transacciones" />,
    component: Transacciones,
    permission: [8],
  },
  rutasIAM,
  {
    link: "/cupo",
    label: <AppIcons Logo={"DETALLES_CUPO"} name={"Detalles Cupo"} />,
    component: cupo,
    permission: [59, 60, 61, 62, 64],
    subRoutes: [
      {
        link: "/cupo/cupo-comercio",
        label: <AppIcons Logo={"RECAUDO"} name={"Cupo comercios"} />,
        component: cupoComercio,
        permission: [62],
      },
      {
        link: "/cupo/ajuste-cartera-cupo",
        label: <AppIcons Logo={"RECAUDO"} name={"Ajuste cartera cupo"} />,
        component: AjusteCupo,
        permission: [59],
      },
      {
        link: "/cupo/detalles-movimiento-cupo",
        label: <AppIcons Logo={"RECAUDO"} name={"Detalle movimiento cupo"} />,
        component: DtlMovCupo,
        permission: [62],
      },
      {
        link: "/cupo/crear-cupo",
        label: <AppIcons Logo={"RECAUDO"} name={"Crear cupo"} />,
        component: CrearCupo,
        permission: [61],
      },
      {
        link: "/cupo/modificar-cupo",
        label: <AppIcons Logo={"RECAUDO"} name={"Modificación cupo"} />,
        component: ModifiCupo,
        permission: [60],
      },
      {
        link: "/cupo/detalle-modificacion-cupo",
        label: <AppIcons Logo={"RECAUDO"} name={"Detalle modificación cupo"} />,
        component: DetalleModificacionCupo,
        permission: [20002],
      },
      {
        link: "/cupo/tipos-movimientos-cupo",
        label: <AppIcons Logo={"RECAUDO"} name={"Tipos de movimientos cupo"} />,
        component: TipoMovimientoCupo,
        permission: [64],
      },
    ],
  },
  rutasColpatria,
  rutasConfiguraciones,
];

export { allUrlsPrivateApps };
